<template>
<div id="avatar">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Consultar Expediente" class="px-1 py-1">
                    <v-card-text>

                        <v-container grid-list-md text-xs-center>

                            <v-row row wrap>
                             
                                <v-col sm="2" md="2" lg="2">
                                   <v-autocomplete  @change="model.busqueda='';" :hide-no-data="true" :items="tipos_busqueda2" v-model="model.tipo_busqueda" item-text="nombre" item-value="id" label="Tipo de Busqueda"></v-autocomplete>
                                </v-col>
                                
                           
                            </v-row>
                            <v-row v-if="model.tipo_busqueda ==1 ">
                                <v-col sm="2" md="2" lg="2">
                                    <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="
                                                                    model.fecha_de = parseDate(model.fecha_de)
                                                                    " v-mask="'####-##-##'" :rules="[
                                                                    rules.required,
                                                                    validaDias,
                                                                    validaFecha,
                                                                    $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)
                                                                    ]">
                                            </v-text-field>
                                        </template>

                                        <v-date-picker v-model="model.fecha_de" color="secondary" landscape scrollable locale="es-mx" @input="menu1 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" large @click="menu1 = false">
                                                Cancelar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col sm="2" md="2" lg="2">
                                    <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                        <template v-slot:activator="{ on }">
                                            <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[
                                                        rules.required,
                                                        validaDias,
                                                        validaFecha,
                                                        $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)
                                                        ]"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="model.fecha_a" color="secondary" landscape scrollable locale="es-mx" @input="menu2 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" large @click="menu2 = false">
                                                Cancelar
                                            </v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col sm="2" md="2" lg="2" class="pt-8">
                                    <v-btn small color="secondary" @click="consulta()">
                                        <v-icon>done</v-icon>Consultar
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-row row wrap>

                            </v-row>
                            <v-row>

                            </v-row>

                            <v-layout style="margin-left:-80px">
                                <v-flex xs4 style="margin-top:-30px">
                                    <v-card class="mx-auto primary" height="550px" max-width="400">
                                        <v-sheet class="pr-5 pl-5 primary">
                                            <v-row>

                                                <v-col cols="12" sm="10" lg="10" class="pl-3 pr-3">
                                                    <v-text-field v-if="model.tipo_busqueda != 1" v-model="model.busqueda" :label="model.tipo_busqueda==2?'Ingrese el Número Pedimento':model.tipo_busqueda==3?'Igrese el Número de Aduana':'Ingrese el Nombre de Archivo'" v-on:keyup.enter="consulta" dark text solo-inverted hide-details clearable clear-icon="mdi-close-circle-outline"></v-text-field>

                                                </v-col>
                                                <v-col v-if="model.tipo_busqueda != 1 && model.tipo_busqueda!=3" cols="12" sm="2" lg="2" class="pa-0 ps-2 pt-5" >
                                                    <v-btn icon dark title="Pegar Listado" @click="dialog1 = !dialog1" v-tippy>
                                                        <v-icon colorHover="secondary" color="white" size="48" >mdi-clipboard-list-outline</v-icon>
                                                    </v-btn>
                                                </v-col>

                                            </v-row>
                                            <v-dialog v-model="dialog1" max-width="500px" style="z-index:1001;">
                                            <v-card>

                                                <v-card-text>
                                                    <h5>Ingrese lista de archivos</h5>
                                                    <small><b>Consulta máxima de 15 pedimentos</b></small>
                                                    <v-textarea outlined rows="15" v-model="listado" ></v-textarea>
                                                </v-card-text>
                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn small @click="listado=''; dialog1 = false" >Cancelar</v-btn>
                                                    <v-btn small color="primary" @click="consulta(); dialog1 = false" >Buscar</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                        </v-sheet>
                                        <v-card-text>
                                            <div class="tree">
                                                <div class="contenido">
                                                    <v-treeview v-model="tree" :items="items" active-class="secondary lighten-4 indigo--text" :active.sync="active" activatable @update:active="preview" returnObject dense :open-all="items.length==1" :key="key">
                                                        <template v-slot:prepend="{ item, open }">
                                                            <v-icon v-if="item.file == 'folder' || item.file == 'grupo' ">{{ open ? 'mdi-folder-open' : 'mdi-folder' }}</v-icon>
                                                            <v-icon v-else>{{ files[item.file.toUpperCase()]?files[item.file.toUpperCase()]:'mdi-file' }}</v-icon>
                                                        </template>
                                                    </v-treeview>
                                                </div>
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs8 style="margin-top:-30px">
                                  
                                    <v-card class="mx-auto primary" height="550px" :key="search" v-if="active.length > 0">
                                        <v-card-title class="primary white--text">
                                            <v-icon small class="white--text">search</v-icon>&nbsp;
                                            <span class="subheading">
                                                <strong>Vista Previa{{file}}</strong>
                                            </span>
                                        </v-card-title>
                                        <v-card-text>
                                            <br />

                                            <table class="table table-condensed white--text">
                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <span id="lab_title_file">RFC:</span>
                                                            <strong>
                                                                <span id="lab_file">{{active[0].rfc}}</span>
                                                            </strong>
                                                        </td>
                                                        <td>
                                                            <span id="lab_title_file">Nombre ZIP:</span>
                                                            <strong>
                                                                <span id="lab_file"> {{active[0].nombre_zip}}</span>
                                                            </strong>
                                                        </td>
                                                        <td>
                                                            <span id="lab_title_file">Archivo:</span>
                                                            <strong>
                                                                <span id="lab_file"> {{active[0].name}}</span>
                                                            </strong>
                                                        </td>

                                                       
                                                        <td>
                                                            <span id="lab_title_file">Fecha:</span>
                                                            <strong>
                                                                <span id="lab_size">{{active[0].fecha}}</span>
                                                            </strong>
                                                        </td>

                                                        <td style="padding-top:5px !important;">

                                                            <v-btn v-if="active[0].file != 'grupo'" rounded color="green" x-small @click="download" title="Descargar" v-tippy>
                                                                <v-icon small>mdi-download</v-icon>Descargar
                                                            </v-btn>
                                                            <v-btn v-if="active[0].file != 'grupo' && active[0].delete == 1" rounded color="red" x-small @click="eliminarAdjunto(active[0].key)" title="Descargar" v-tippy>
                                                                <v-icon dark small>delete</v-icon>Eliminar
                                                            </v-btn>
                                                           
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div v-if="active[0].file.toUpperCase() =='XML' || active[0].file.toUpperCase() =='TXT' ||  parseInt(active[0].file)  > 0  || active[0].file.toUpperCase()  =='ERR'" class="global">
                                                <div class="contenidotxt">
                                                    <pre>{{xmlContent}} </pre>
                                                </div>
                                            </div>

                                            <div id="app" v-if="( active[0].file.toUpperCase() =='PDF') && url!='' ">
                                                <PDFViewer v-bind="{url}" @document-errored="onDocumentErrored"></PDFViewer>
                                            </div>
                                            <div v-if="active[0].file.toUpperCase() =='JPG' || active[0].file.toUpperCase() =='JPEG'" class="global">
                                                <div class="contenido">
                                                    <v-img :src="`data:image/jpg;base64,${url}`" max-width="900px"></v-img>
                                                </div>

                                            </div>
                                            <div v-if="active[0].file.toUpperCase() =='PNG'" class="global">
                                                <div class="contenido">
                                                    <v-img :src="`data:image/png;base64,${url}`" max-width="900px"></v-img>
                                                </div>

                                            </div>
                                            <v-alert border="top" colored-border type="info" elevation="2" v-if="active[0].file.toUpperCase() !='PDF'  
                                        && active[0].file.toUpperCase()  !='XML' && active[0].file.toUpperCase()  !='PNG' && active[0].file.toUpperCase()  !='JPG' && active[0].file.toUpperCase()  !='JPEG' && active[0].file.toUpperCase()  !='TXT' 
                                        && active[0].file !=''  && !parseInt(active[0].file)>0  && active[0].file.toUpperCase()  !='ERR' ">Vista previa no disponible.
                                            </v-alert>

                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </base-material-card>

            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import {
    request
} from "http";
import {
    mapState
} from "vuex";
import axios from "axios";
import PDFViewer from "@/components/pdf/PDFViewer.vue";
import beautify from "xml-beautifier";
import moment from "moment";

export default {
    components: {
        PDFViewer
    },
    created() {
        this.URL = this.$hostname;
        this.model.usuario = this.$local_storage.get("id_usuario");

        var tipoUsuario = this.$local_storage.get("tipo_usuario");
        if (this.$local_storage.get("es_transportista") == 1 || this.$local_storage.get("es_agente") == 1) {
            this.model.rfc_grupo = this.$local_storage.get("rfc_grupo");
            this.es_grupo = 1;
            this.getClientesTransportista();
        } else {
            this.model.rfc = this.$local_storage.get("rfc");
            this.getTransportistas();
        }
    },
    computed: {

    },
    mounted() {},
    methods: {
        consulta: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var filenames= [];
            if (this.model.tipo_busqueda != 1) {
                this.model.fecha_de = "";
                this.model.fecha_a = "";
            }
            if (this.listado.split("\n").length > 15) {
                this.$root.$dialogLoader.hide();
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: 'El máximo de pedimentos en la lista es 15',
                    footer: '',
                });
                return false;
            }else{
                filenames= this.listado.split("\n");              
            }
           
       /*      
            280-1864-2006786
            530-1864-2005816
            con coves
            ATE830825TI4
            470-3807-2002548
            */ 
            
            let data = this.model;
            if(filenames.length>0 && this.listado !="" ){
                data.lista = filenames;
                data.busqueda = "";
            }
            this.listado="";
            let self = this;
            self.items =[];

            axios.post(this.URL + "vucem/edrive_carta/", data)
                .then(res => {
                   
                    if (typeof res.data !== "undefined") {
                        let data = res.data;

                        data = res.data.sort(function (a, b) {
                            return a.no_pedimento > b.no_pedimento;
                        });
                        if (data.length > 0) {
                            var carpetas = [];
                           data.forEach(function (item) {
                            //    if (carpetas.includes(item.no_pedimento.toUpperCase()) == false) {
                                    carpetas.push({no_pedimento:item.no_pedimento.toUpperCase(), rfc:item.rfc, nombre_zip:item.nombre_zip, fecha:item.fecha, path_recuperaciones:item.path_recuperaciones});
                             //   }
                            });
                          
                                  
                                  var l = 1
                                    carpetas.forEach(function (y) {
                                                var child = [];
                                                data.forEach(function (z) {
                                                    if( y.no_pedimento.toUpperCase() == z.no_pedimento.toUpperCase()){
                                                        let name = z.key.slice(z.key.lastIndexOf('/') + 1);
                                                        name = name.substr(name.indexOf('_') + 1) ;
                                                        child.push({
                                                            id:  l + 10,
                                                            name:  name,
                                                            dir: z.key ,
                                                            file: z.key.substring(z.key.length - 3),
                                                            size: 0,
                                                            bucket: z.bucket,
                                                            fecha: z.fecha,
                                                            rfc: z.rfc,
                                                            delete: 0,
                                                            nombre_zip: z.nombre_zip
                                                        });
                                                        l+=1;   
                                                        if(z.key_pdf != ""){
                                                            let name2 = z.key_pdf.slice(z.key_pdf.lastIndexOf('/') + 1);
                                                            name2 = name2.substr(name2.indexOf('_') + 1) ;
                                                            child.push({
                                                                id:  l + 10,
                                                                name:  name2,
                                                                dir: z.key_pdf ,
                                                                file: "pdf",
                                                                size: 0,
                                                                bucket: z.bucket,
                                                                fecha: z.fecha,
                                                                rfc: z.rfc,
                                                                delete: 0,
                                                                nombre_zip: z.nombre_zip
                                                            });
                                                            l+=1;    

                                                        }
                                                        
                                                    }
                                                        
                                                });
                                                var no_esta = true;
                                                data.forEach(function (z) {
                                                    if( no_esta && y.no_pedimento.toUpperCase() == z.no_pedimento.toUpperCase()){
                                                       
                                                        l+=1;    
                                                        //revisamos si trae contenido
                                                            //revisamos si hay cartas
                                                            var cartas_items = []
                                                            var k=l;
                                                            if ( z.contenido.cartas.length > 0){
                                                                z.contenido.cartas.forEach(function (w) {
                                                                    let _delete = 0;
                                                                    if (w.key.substring(w.key.length - 3).toUpperCase() == 'XML')
                                                                        _delete = 1
                                                                    cartas_items.push({
                                                                        id:  k + 100,
                                                                        name: w.key.slice(w.key.lastIndexOf('/') + 1) ,
                                                                        dir: w.key ,
                                                                        file: w.key.substring(w.key.length - 3),
                                                                        size: 0,
                                                                        bucket: 'production.econnect.ds',
                                                                        fecha: z.fecha,
                                                                        rfc: z.rfc,
                                                                        delete: _delete
                                                                        
                                                                    });
                                                                    k+=1;
                                                                });
                                                                 child.push(
                                                                    {
                                                                            id:  y.no_pedimento + ".cp",
                                                                            name: "CartaPorte",
                                                                            dir: '' ,
                                                                            file: "grupo",
                                                                            size: 0,
                                                                            children: cartas_items
                                                                    } );
                                                                    no_esta = false;
                                                            }
                                                            //revisamos si hay pagos
                                                            var pagos_items = []
                                                            var k=l;
                                                            if ( z.contenido.pagos.length > 0 || z.contenido.adjuntos.length > 0 ){
                                                                z.contenido.pagos.forEach(function (w) {
                                                                    let name2 =  w.key.slice(w.key.lastIndexOf('/') + 1);
                                                                    name2 = name2.substr(name2.indexOf('_') + 1) ;
                                                                    pagos_items.push({
                                                                        id:  k + 1000,
                                                                        name: name2 ,
                                                                        dir: w.key ,
                                                                        file: w.key.substring(w.key.length - 3),
                                                                        size: 0,
                                                                        bucket: 'production.econnect.ds',
                                                                        fecha: z.fecha,
                                                                        rfc: z.rfc,
                                                                        delete: 1
                                                                    });
                                                                    k+=1;
                                                                });
                                                                //archivos pedimento
                                                                z.contenido.adjuntos.forEach(function (j) {
                                                                    var sub = j.key.slice(j.key.lastIndexOf('/') + 1).split("_");
                                                                    if (j.key.substring(j.key.length - 3) == 'ERR' || j.key.substring(j.key.length - 3) == 'err' || parseInt(j.key.substring(j.key.length - 3)) > 0 )
                                                                    {
                                                                        pagos_items.push({
                                                                            id:  k + 10000,
                                                                            name: j.key.slice(j.key.lastIndexOf('/') + 1) ,
                                                                            dir: j.key ,
                                                                            file: j.key.substring(j.key.length - 3),
                                                                            size: 0,
                                                                            bucket: 'production.econnect.ds',
                                                                            fecha: z.fecha,
                                                                            rfc: z.rfc,
                                                                            delete: 1
                                                                        });
                                                                        k+=1;
                                                                    }
                                                                });
                                                                if(pagos_items.length > 0)
                                                                 child.push(
                                                                    {
                                                                            id:  y.no_pedimento + ".ap",
                                                                            name: "ArchivosPedimento",
                                                                            dir: '' ,
                                                                            file: "grupo",
                                                                            size: 0,
                                                                            children: pagos_items
                                                                    } );
                                                                    no_esta = false;
                                                            }
                                                            //revisamos si hay adjuntos
                                                            var adjuntos_items = []
                                                            var k=l;
                                                            if ( z.contenido.adjuntos.length > 0 ){
                                                                
                                                                z.contenido.adjuntos.forEach(function (m) {
                                                                    var sub = m.key.slice(m.key.lastIndexOf('/') + 1).split("_");
                                                                    if ( m.key.substring(m.key.length - 3) != 'err' && parseInt(m.key.substring(m.key.length - 3)) == 0)
                                                                    {
                                                                        adjuntos_items.push({
                                                                            id:  k + 100000,
                                                                            name: m.key.slice(m.key.lastIndexOf('/') + 1) ,
                                                                            dir: m.key ,
                                                                            file: m.key.substring(m.key.length - 3),
                                                                            size: 0,
                                                                            bucket: 'production.econnect.ds',
                                                                            fecha: z.fecha,
                                                                            rfc: z.rfc,
                                                                            delete: 1
                                                                        });
                                                                        k+=1;
                                                                    }
                                                                });
                                                                if(adjuntos_items.length > 0)
                                                                 child.push(
                                                                    {
                                                                            id:  y.no_pedimento + ".ad",
                                                                            name: "Adjuntos",
                                                                            dir: '' ,
                                                                            file: "grupo",
                                                                            size: 0,
                                                                            children: adjuntos_items
                                                                    } );
                                                                    no_esta = false;
                                                            }
                                                            //revisamos si hay coves
                                                            var coves_items = []
                                                            var edocs_items = []
                                                            var m=l;
                                                            let tipo = "";
                                                            if (z.contenido.recuperaciones!=undefined && z.contenido.recuperaciones.length > 0){
                                                                z.contenido.recuperaciones.forEach(function (v) {
                                                                    //revisa coves
                                                                    if((v.tipo == 7 || v.tipo == 8 || v.tipo == 10 ) && v.estatus == 2)
                                                                    {
                                                                    if(v.tipo == 7 || v.tipo==10 )
                                                                        tipo= "pdf";
                                                                    if(v.tipo == 8)
                                                                        tipo= "xml";
                                                                        coves_items.push({
                                                                            id:  m + + 1000000,
                                                                            name: v.filename + "." + tipo ,
                                                                            dir: y.path_recuperaciones  + v.filename  + "." + tipo,
                                                                            file: tipo,
                                                                            size: 0,
                                                                            bucket: 'production.econnect.ds',
                                                                            fecha: z.fecha,
                                                                            rfc: z.rfc,
                                                                            delete: 0
                                                                        });
                                                                    m+=1;
                                                                    }
                                                                    //revisa edocs
                                                                    if((v.tipo == 11 || v.tipo == 12 || v.tipo == 14) && v.estatus == 2)
                                                                    {
                                                                   
                                                                    if(v.tipo == 11 || v.tipo==14 )
                                                                        tipo= "pdf";
                                                                    if(v.tipo == 12 )
                                                                        tipo= "xml";   
                                                                        edocs_items.push({
                                                                            id:  m + + 1000000,
                                                                            name: v.filename + "." + tipo,
                                                                            dir: y.path_recuperaciones  + v.filename  + "." + tipo,
                                                                            file: tipo,
                                                                            size: 0,
                                                                            bucket: 'production.econnect.ds',
                                                                            fecha: z.fecha,
                                                                            rfc: z.rfc,
                                                                            delete: 0
                                                                        });
                                                                    m+=1;
                                                                    }
                                                                });
                                                                if(coves_items.length>0)
                                                                 child.push(
                                                                    {
                                                                            id:  y.no_pedimento + ".cv",
                                                                            name: "COVES",
                                                                            dir: '' ,
                                                                            file: "grupo",
                                                                            size: 0,
                                                                            children: coves_items
                                                                    } );
                                                                if(edocs_items.length>0)
                                                                 child.push(
                                                                    {
                                                                            id:  y.no_pedimento + ".edc",
                                                                            name: "EDOCS",
                                                                            dir: '' ,
                                                                            file: "grupo",
                                                                            size: 0,
                                                                            children: edocs_items
                                                                    } );
                                                                   
                                                            }
                                                      
                                                      


                                                    }
                                                        
                                                });


                                                self.items.push(
                                                {
                                                        id:  y.no_pedimento,
                                                        name: y.no_pedimento,
                                                        dir: '' ,
                                                        file: "grupo",
                                                        size: 0,
                                                        children: child,
                                                        nombre_zip: y.nombre_zip,
                                                        rfc: y.rfc,
                                                        fecha:y.fecha,
                                                        path_recuperaciones:y.path_recuperaciones
                                                } );

                                               
                                                
                                 });
                        }

                    }
                })
                .catch(err => {
                
                    console.log(err);

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        base64ToArrayBuffer: function (base64) {
            var binaryString = window.atob(base64);
            var binaryLen = binaryString.length;
            var bytes = new Uint8Array(binaryLen);
            for (var i = 0; i < binaryLen; i++) {
                var ascii = binaryString.charCodeAt(i);
                bytes[i] = ascii;
            }
            return bytes;
        },
        preview() {
            // Para eliminar todo el expediente
            this.borrableExpediente = false;
            if (this.active.length > 0 && Number.isInteger(this.active[0].id) && this.active[0].file == "folder") {
                this.borrableExpediente = true;
            }

            this.borrable = !this.active.length || this.active[0].dir.indexOf('adjuntos') > 0 && this.active[0].file != "zip" && this.active[0].file != "folder";

            if (!this.active.length || this.active[0].file == "zip" || this.active[0].file == "folder") {
                return undefined;
            }

            if (this.active[0].file.toUpperCase() == "PDF" || this.active[0].file.toUpperCase() == "XML" || this.active[0].file.toUpperCase() == "PNG" || this.active[0].file.toUpperCase() == "JPG" || this.active[0].file.toUpperCase() == "JPEG" || this.active[0].file.toUpperCase() == 'TXT' || parseInt(this.active[0].file) > 0 || this.active[0].file.toUpperCase() == 'ERR') {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                this.xmlError = false;
                var datos = {
                    id: this.active[0].dir,
                    bucket: this.active[0].bucket
                }
                this.xmlContent = "";
                var result = "";
                axios.post(this.$hostname + 's3/download/', datos)
                    .then((response) => {
                        if (typeof response.data !== 'undefined') {
                            let blob = new Blob([this.base64ToArrayBuffer(response.data)], {
                                    type: response.headers["content-type"]
                                }),
                                url = window.URL.createObjectURL(blob);
                            if (this.active[0].file.toUpperCase() == "PDF") {
                                this.url = url;
                            }
                            if (this.active[0].file.toUpperCase() == "XML") {
                                this.xmlContent = beautify(atob(response.data));
                            }
                            if (this.active[0].file.toUpperCase() == 'TXT' || parseInt(this.active[0].file) > 0 || this.active[0].file.toUpperCase() == 'ERR') {
                                this.xmlContent = atob(response.data)
                            }
                            if (this.active[0].file.toUpperCase() == "PNG" || this.active[0].file.toUpperCase() == "JPG" || this.active[0].file.toUpperCase() == "JPEG") {
                                this.url = response.data
                            }
                        } else {
                            this.url = "";

                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                                footer: '',
                            });
                        }
                        this.borrable = this.active[0].dir.indexOf('adjuntos') > 0 && this.active[0].file != "zip" && this.active[0].file != "folder";
                        this.$root.$dialogLoader.hide();
                    })
                    .catch((error) => {
                        this.url = "";
                        this.xmlContent = ""
                        if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined && error.response.data.mensaje == "Archivo no encontrado") {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                                footer: '',
                            });
                            this.$root.$dialogLoader.hide();
                        } else {
                            this.$swal({
                                type: "info",
                                title: "Importante",
                                text: "El tamaño del archivo no permite mostrarlo en el visor de documentos ¿Desea descargar el archivo?",
                                footer: "",
                                showCancelButton: true,
                                cancelButtonColor: "#d33",
                                confirmButtonColor: "#3085d6",
                                confirmButtonText: "Aceptar",
                                cancelButtonText: "Cancelar"
                            }).then(result => {
                                if (result.value) {
                                    this.downloadFileUrl(datos.id);
                                } else {
                                    this.$root.$dialogLoader.hide();
                                }
                            });
                        }
                        this.borrable = this.active[0].dir.indexOf('adjuntos') > 0 && this.active[0].file != "zip" && this.active[0].file != "folder";

                    });
            }

        },
        download() {
            if (this.active[0].file == "zip" || this.active[0].file == "folder") {
                this.generateZip(this.active[0].dir);
            } else {
                if (this.active[0].file.toUpperCase() == "XML") {
                    this.downloadFile(this.active[0].dir, this.active[0].bucket);
                } else {
                    try {
                        if (parseFloat(this.active[0].size) > 3.5) //Si pesa mas de 3.5MB que lo baje por url
                            this.downloadFileUrl(this.active[0].dir);
                        else
                            this.downloadFile(this.active[0].dir, this.active[0].bucket);
                    } catch (error) {
                        this.downloadFileUrl(this.active[0].dir);
                    }

                }
            }

        },

        parseDate(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD");
        },
        parseDateTime(date) {
            //Formato  YYYY-MM-DD
            if (!date) return null;
            return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
        },

        urlUpdated(url) {
            this.documentError = undefined;
            this.url = url;
        },

        onDocumentErrored(e) {
            this.documentError = e.text;
        },

        buscar: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            this.active = [];
            if (this.search === null) {
                this.$root.$dialogLoader.hide();
                return false;
            }
            var data = {
                rfc: this.$local_storage.get("rfc"),
                filename: this.search,
            };
            axios
                .post(this.$apiReportes + "reportes/get_consulta_file/", data)
                .then(res => {
                    var self = this;
                    self.items = [];
                    if (res.data.length > 0) {
                        res.data.forEach(function (item) {
                            var i = 1;
                            var children = [];
                            var coves = [];
                            var edocuments = [];
                            var remesas = [];
                            var adjuntos = [];
                            var af_file = [];
                            var size_partidas = 0;
                            var cuenta_partidas = 0;
                            var size_coves = 0;
                            var size_edocuments = 0;
                            var size_remesas = 0;
                            var size_adjuntos = 0;
                            var size_af = 0;
                            self.key = item.id;
                            item.validacion.forEach(function (v) {
                                if (v.size > 0) {
                                    v.size = (((v.size / 1024)) / 1024).toFixed(3);
                                }
                                if (v.estatus == 2) {
                                    if (v.tipo < 6 || v.tipo == 19 || v.tipo == 20) {
                                        children.push({
                                            id: v.filename + "." + v.ext,
                                            name: v.filename + "." + v.ext,
                                            dir: item.path + v.filename + "." + v.ext,
                                            file: v.ext,
                                            size: v.size,
                                            expediente: false
                                        });
                                    }

                                    if (v.tipo == 'remesas') {
                                        children.push({
                                            id: v.filename + "." + v.ext,
                                            name: v.filename + "." + v.ext,
                                            dir: item.path + v.filename + "." + v.ext,
                                            file: v.ext,
                                            size: v.size,
                                            expediente: false
                                        });
                                    }

                                    if (v.tipo == 6) {
                                        size_partidas = size_partidas + parseFloat(v.size);
                                        cuenta_partidas += 1;
                                    }
                                    if ((v.tipo == 7 || v.tipo == 8 || v.tipo == 10)) {
                                        coves.push({
                                            id: v.filename + "." + v.ext,
                                            name: v.filename + "." + v.ext,
                                            dir: item.path + "coves/" + v.filename + "." + v.ext,
                                            file: v.ext,
                                            size: v.size,
                                            expediente: false
                                        });
                                        size_coves = size_coves + parseFloat(v.size);
                                    }
                                    if ((v.tipo == 11 || v.tipo == 12 || v.tipo == 14)) {
                                        edocuments.push({
                                            id: v.filename + "." + v.ext,
                                            name: v.filename + "." + v.ext,
                                            dir: item.path + "eDocuments/" + v.filename + "." + v.ext,
                                            file: v.ext,
                                            size: v.size,
                                            expediente: false
                                        });
                                        size_edocuments = size_edocuments + parseFloat(v.size);
                                    }
                                    if ((v.tipo == 15 || v.tipo == 16 || v.tipo == 18)) {
                                        remesas.push({
                                            id: v.filename + "." + v.ext,
                                            name: v.filename + "." + v.ext,
                                            dir: item.path + "coves/" + v.filename + "." + v.ext,
                                            file: v.ext,
                                            size: v.size,
                                            expediente: false
                                        });
                                        size_remesas = size_remesas + parseFloat(v.size);
                                    }
                                    i = i + 1;
                                }

                            });

                            var carpetas_adjuntos = [];
                            let tiene_archivos_pedimento = false;
                            let tiene_AF = false;
                            item.adjuntos = item.adjuntos.sort(function (a, b) {
                                return a.filename > b.filename;
                            });
                            item.adjuntos.forEach(function (j) {
                                var sub = j.filename.split("_");
                                if (sub.length > 0) {
                                    if (carpetas_adjuntos.includes(sub[0]) == false) {
                                        if (sub[0] != 'P030' && sub[0] != 'P031' && sub[0] != 'P032' && sub[0] != 'P033' && !sub[0].toUpperCase().startsWith('AF')) {
                                            carpetas_adjuntos.push(sub[0]);
                                        } else {
                                            if (sub[0] == 'P030' || sub[0] == 'P031' || sub[0] == 'P032' || sub[0] == 'P033')
                                                tiene_archivos_pedimento = true;

                                        }
                                    }
                                }
                            });
                            if (tiene_archivos_pedimento) {
                                carpetas_adjuntos.push("ArchivosPedimento");
                            }
                            var l = 0;
                            var size = 0;
                            var child_af = [];
                            var child_af_size = 0;
                            carpetas_adjuntos.forEach(function (y) {
                                var child_adjuntos = [];
                                var child_adjuntos_size = 0;

                                var w = 1;
                                item.adjuntos.forEach(function (z) {
                                    size = 0;
                                    if (z.size > 0) {
                                        size = parseFloat((((z.size / 1024)) / 1024)).toFixed(3);
                                    }
                                    var sub = z.filename.split("_");
                                    if (sub.length > 0) {
                                        if (sub[0] == y || (y == "ArchivosPedimento" && (sub[0] == 'P030' || sub[0] == 'P031' || sub[0] == 'P032' || sub[0] == 'P033'))) {
                                            sub = sub[0] + "/";
                                            child_adjuntos.push({
                                                id: sub + z.filename + "." + z.ext,
                                                name: z.filename + "." + z.ext,
                                                dir: item.path + "adjuntos/" + sub + z.filename + "." + z.ext,
                                                file: z.ext,
                                                size: size,
                                                expediente: false
                                            });
                                            child_adjuntos_size = child_adjuntos_size + parseFloat(z.size);
                                        }

                                    }
                                    w = w + 1;

                                });
                                size = 0;
                                if (child_adjuntos_size > 0) {
                                    size = parseFloat((((child_adjuntos_size / 1024)) / 1024)).toFixed(3);
                                }
                                if (y == "ArchivosPedimento") {
                                    adjuntos.push({
                                        id: item.id * l + 100000,
                                        name: y,
                                        dir: "",
                                        file: "grupo",
                                        size: size,
                                        children: child_adjuntos,
                                        expediente: false
                                    });
                                } else {

                                    adjuntos.push({
                                        id: item.id * l + 100000,
                                        name: y,
                                        dir: item.path + "adjuntos/" + y,
                                        file: "folder",
                                        size: size,
                                        children: child_adjuntos,
                                        expediente: false
                                    });
                                }

                                size_adjuntos = size_adjuntos + parseFloat(child_adjuntos_size);

                                l = l + 1;
                            });

                            // llena los AF
                            item.adjuntos.forEach(function (z) {
                                size = 0;
                                if (z.size > 0) {
                                    size = parseFloat((((z.size / 1024)) / 1024)).toFixed(3);
                                }
                                var sub = z.filename.split("_");
                                if (sub.length > 0) {

                                    if (sub[0].toUpperCase().startsWith('AF')) {
                                        sub = sub[0] + "/";
                                        child_af.push({
                                            id: sub + z.filename + "." + z.ext,
                                            name: z.filename + "." + z.ext,
                                            dir: item.path + "adjuntos/" + sub + z.filename + "." + z.ext,
                                            file: z.ext,
                                            size: size,
                                            expediente: false
                                        });
                                        child_af_size = child_af_size + parseFloat(z.size);
                                    }
                                }
                            });

                            if (cuenta_partidas > 0) {
                                children.push({
                                    id: "Partidas",
                                    name: "Partidas (" + cuenta_partidas + ").zip",
                                    dir: item.path + "partidas",
                                    file: "zip",
                                    size: size_partidas.toFixed(2),
                                    expediente: false
                                });
                            }
                            if (coves.length > 0) {
                                children.push({
                                    id: "coves",
                                    name: "Coves",
                                    dir: item.path + "coves",
                                    file: "folder",
                                    size: size_coves.toFixed(2),
                                    children: coves,
                                    expediente: false
                                });

                            }
                            if (edocuments.length > 0) {
                                children.push({
                                    id: "Edocuments",
                                    name: "Edocuments",
                                    dir: item.path + "eDocuments",
                                    file: "folder",
                                    size: size_edocuments.toFixed(2),
                                    children: edocuments,
                                    expediente: false
                                });

                            }
                            if (remesas.length > 0) {
                                children.push({
                                    id: "coves",
                                    name: "Coves",
                                    dir: item.path + "coves",
                                    file: "folder",
                                    size: size_remesas.toFixed(2),
                                    children: remesas,
                                    expediente: false
                                });

                            }

                            if (child_af.length > 0) {
                                children.push({
                                    id: "AFFILE",
                                    name: "AF_FILE",
                                    dir: item.path + "af_file",
                                    file: "folder",
                                    size: ((child_af_size / 1024) / 1024).toFixed(2),
                                    children: child_af,
                                    expediente: false
                                });

                            }
                            if (adjuntos.length > 0) {
                                children.push({
                                    id: "Adjuntos",
                                    name: "Adjuntos",
                                    dir: item.path + "adjuntos",
                                    file: "folder",
                                    size: ((size_adjuntos / 1024) / 1024).toFixed(2),
                                    children: adjuntos,
                                    expediente: false
                                });

                            }
                            var pathPedimento = self.$local_storage.get("rfc") + "/pedimentos/" + item.anio.toString();
                            if (item.path != null && item.path != undefined && item.path != "") {
                                pathPedimento = item.path
                            }
                            self.items.push({
                                id: item.id,
                                name: item.no_pedimento,
                                dir: pathPedimento,
                                file: "folder",
                                size: ((item.size / 1024) / 1024).toFixed(2),
                                children: children,
                                datastage: item.datastage,
                                expediente: true
                            });

                        });
                    } else {
                        this.$swal({
                            type: "error",
                            title: "No se encontraron resultados",
                            text: this.search,
                            footer: ""
                        });
                    }
                    this.$root.$dialogLoader.hide();
                })
                .catch(err => {
                    this.$root.$dialogLoader.hide();
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al consultar el archivo",
                        footer: ""
                    });
                    console.log(err);
                });

        },

        downloadFile: function (key, bucket) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: key,
                bucket: bucket
            }
            axios.post(this.$hostname + 's3/download/', datos)
                .then((response) => {

                    if (typeof response.data !== 'undefined') {

                        let blob = new Blob([this.base64ToArrayBuffer(response.data)], {
                                type: response.headers["content-type"]
                            }),
                            url = window.URL.createObjectURL(blob);

                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";

                        a.href = url;
                        var arreglo = key.split("/")
                        a.download = arreglo[arreglo.length - 1];
                        a.click();

                        a.parentNode.removeChild(a);
                        this.$root.$dialogLoader.hide();
                    } else {
                        this.$root.$dialogLoader.hide();
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    this.$root.$dialogLoader.hide();
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                });
        },

        generateZip: function (key) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                key: key,
                usuario: this.$local_storage.get("id_usuario"),
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_zip/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        this.$swal({
                            type: "info",
                            title: "Generado...",
                            text: "En breve recibirás una notificación para descargar el ZIP",
                            footer: '',
                        });
                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
        downloadFileUrl: function (dir) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var datos = {
                id: dir,
                bucket: "production.econnect.ds"
            }
            axios.post(this.$hostname + 's3/download_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        a.href = res.data.mensaje;
                        a.target = "_blank";
                        a.click();
                        a.parentNode.removeChild(a);

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al descargar el archivo";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                }).then(() => {
                    this.$root.$dialogLoader.hide();
                });

        },
        getNombreGrupo: function (row) {
            return row.rfc + " - " + row.grupo;
        },
        getTransportistas: function () {
            let data = {
                id_cliente: this.$local_storage.get("id_cliente"),
            };
            axios.post(this.$hostname + "grupos/get_grupos_rfc/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.gruposTransportistas = res.data;

                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los grupos.",
                        footer: ""
                    });
                    console.log(err);
                });
        },
        getNombreCliente: function (row) {
            if (row.metadato != null && row.metadato != "")
                return row.rfc + " - " + row.metadato;
            else
                return row.rfc + " - " + row.razon_social;
        },
        getClientesTransportista: function () {
            let data = {
                id_grupo: this.$local_storage.get("id_grupo"),
            };
            axios.post(this.$hostname + "grupos/get_rfcs/", data)
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.clientesTransportista = res.data;
                    }
                })
                .catch(err => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los clientes.",
                        footer: ""
                    });
                    console.log(err);
                });
        },
        validaDias: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, "days");
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial.";
                if (Math.abs(diferencia) > 365)
                    return "Periodo máximo de consulta 365 dias. Favor de verificar.";
            }
            return true;
        },
        validaFecha: function (fecha) {
            if (fecha == "Invalid date")
                return "Fecha no válida."

            return true;
        },
        validaAnio: function () {
            if (this.model.fecha_de != "" && this.model.fecha_a != "") {
                var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
                var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
                var diferencia = fin.diff(inicio, 'days')
                if (diferencia < 0)
                    return "La Fecha Final no debe ser menor a la Fecha Inicial."
            }
            return true;
        },
        eliminarAdjunto: function (key) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
            }).then((result) => {
                if (result.value) {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    var datos = {
                        key: key,
                    };
                    axios
                        .post(this.$hostname + "vucem/eliminar_archivo_adjunto/", datos)
                        .then((res) => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El registro se eliminó correctamente",
                                footer: "",
                            });
                        })
                        .catch((error) => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar el registro. Favor de comunicarse con soporte.",
                                footer: "",
                            });
                            console.log(error);
                        })
                        .then(() => {
                            this.$root.$dialogLoader.hide();
                            this.consulta();
                        });
                }
            });
        },

    },
    data: () => ({
        model: {
            tipo_busqueda: 2,
            rfc: "",
            rfc_grupo: "",
            fecha_de: "",
            fecha_a: "",
            busqueda: "",
        },
        rules: {
            required: v => !!v || "Este campo es requerido",
            numeric: value => {
                const pattern = /^[\d]*$/;
                return pattern.test(value) || "Solo se permiten números";
            }
        },
        menu1: false,
        menu2: false,
        gruposTransportistas: [],
        clientesTransportista: [],
        es_grupo: false,
        tipos_archivo: [{
            "id": 1,
            "nombre": "CFDI"
        }, {
            "id": 2,
            "nombre": "Archivo M"
        }],
        tipos_busqueda1: [{
            "id": 1,
            "nombre": "Periodo de Fecha"
        }, {
            "id": 4,
            "nombre": "Nombre de Archivo"
        }],
        tipos_busqueda2: [{
            "id": 1,
            "nombre": "Fechas de Pedimento"
        }, {
            "id": 2,
            "nombre": "Número de Pedimento"
        }, {
            "id": 3,
            "nombre": "Aduana de Pedimento"
        }, {
            "id": 4,
            "nombre": "Nombre de Archivo"
        }],
        fab: false,
        xmlError: false,
        xmlContent: "",
        url: "",
        file: "",
        search: null,
        key: 1,
        active: [],
        sel: null,
        URL: "",
        dialog1: false,
        confirm: false,
        confirmExpediente: false,
        confirmCarpeta: false,
        listado: "",
        files: {
            PDF: "mdi-file-pdf-box",
            PNG: "mdi-file-png-box",
            JPG: "mdi-file-jpg-box",
            TXT: "mdi-file-document-outline",
            XLS: "mdi-file-excel-box",
            XLSX: "mdi-file-excel-box",
            DOCX: "mdi-file-word-box",
            DOC: "mdi-file-word-box",
            XML: "mdi-xml",
            ZIP: "mdi-zip-box"
        },

        tree: [],
        items: [],
        borrable: false,
        borrableExpediente: false,
        borrableCarpeta: false,
        comentario: "",
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/indext"
            },
            {
                text: "Consultar Expediente",
                disabled: true,
                to: ""
            }
        ],
    })
};
</script>

<style scoped>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: white;
    margin-top: 0px;
}

.error {
    border: 1px solid red;
    background: pink;
    color: red;
    padding: 0.5em 3em;
    display: inline;
}

.box-shadow {
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
        0 5px 15px 0 rgba(0, 0, 0, 0.08);
}

.overflow-hidden {
    overflow: hidden;
}

@media print {
    body {
        background-color: transparent;
    }

    #app {
        margin: 0;
        padding: 0;
    }
}

.global {
    margin-left: 10px;
    margin-top: 20px;
    height: 432px;
    width: 100%;
    border: 1px solid #ddd;
    background-color: white;
    overflow: scroll;
}

.tree {
    margin-left: 0px;
    margin-top: -20px;
    height: 450px;
    width: 100%;
    border: 1px solid #ddd;
    background-color: white;
    overflow-y: scroll;
}

.contenido {
    padding: 5px;
    font-size: small;
    overflow: auto;
    background-color: white;
}

.contenidotxt {
    padding: 5px;
    font-size: small;
    overflow: auto;
    font-size: 14px !important;
    background-color: white;
}

.v-card__subtitle,
.v-card__text {
    line-height: 0.95rem !important;
}

.v-treeview--dense .v-treeview-node__root {
    min-height: 20px !important;
}

.table {
    font-size: 12px !important;
    margin-bottom: 20px;
}

.v-label {
    font-size: 8px !important;
}
</style>
